import React from 'react';
import type { SteelTableRow } from '../../lib/dlpSteelTable';

interface SteelReportTableProps {
  title: string;
  rows: SteelTableRow[];
  caption?: string;
  /** Raw Data 엑셀 링크(IPT-441 후속) — 있으면 제목 옆에 "(링크)"를 표시한다 */
  linkUrl?: string;
  /**
   * 화면에 렌더링할 컬럼 순서를 명시적으로 강제한다 (IPT-622/623, 2026-09-16).
   * 지정하지 않으면 rows[0]의 키 순서를 그대로 쓴다 — 다만 운영 캐시(JSONB) 왕복 과정에서
   * 원본 API가 준 키 순서가 보존되지 않는 표는 반드시 지정해야 한다.
   */
  columnOrder?: string[];
  /** 컬럼 키 → 화면 표시 라벨 (지정 없으면 키 그대로 헤더에 사용) */
  columnLabels?: Record<string, string>;
}

/**
 * 세아제강 DLP 표(임의 컬럼) 공통 렌더러 (IPT-441).
 * Privacy-i API가 주는 표는 컬럼 구성이 전부 달라, rows의 키를 그대로 헤더로 쓴다.
 */
export const SteelReportTable: React.FC<SteelReportTableProps> = ({
  title,
  rows,
  caption,
  linkUrl,
  columnOrder,
  columnLabels,
}) => {
  const columns = columnOrder ?? (rows.length > 0 ? Object.keys(rows[0]) : []);

  return (
    <div className="steel-report-table" style={{ marginBottom: '1.5rem' }}>
      <h3>
        {title}
        {linkUrl && (
          <>
            {' '}(<a href={linkUrl} target="_blank" rel="noopener noreferrer">링크</a>)
          </>
        )}
      </h3>
      {caption && <p className="steel-table-caption" style={{ color: '#666', fontSize: '0.85rem' }}>{caption}</p>}
      {rows.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '1rem' }}>데이터가 없습니다.</div>
      ) : (
        <table className="policy-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{columnLabels?.[col] ?? col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} className={row.isSummaryRow ? 'steel-summary-row' : undefined}>
                {columns.map((col) => (
                  <td key={col}>{row[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
